import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/liveGuide/webguide.svg'


const _withScopeId = n => (_pushScopeId("data-v-0a1e4d50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap select_none" }
const _hoisted_2 = { class: "mod_c_title hear" }
const _hoisted_3 = {
  key: 1,
  class: "box flex"
}
const _hoisted_4 = { class: "play_interface_web" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"432px"}
}, null, -1))
const _hoisted_6 = { class: "bullet_box" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "弹幕内容", -1))
const _hoisted_9 = { style: {"flex":"1"} }
const _hoisted_10 = { class: "address" }
const _hoisted_11 = ["data-clipboard-text"]
const _hoisted_12 = { class: "bullet_set" }
const _hoisted_13 = {
  class: "color_set",
  style: {"flex":"1"}
}
const _hoisted_14 = { class: "add_color" }
const _hoisted_15 = { class: "bg_set" }
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = { class: "bg_color" }
const _hoisted_18 = { class: "speed_set" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 秒", -1))
const _hoisted_20 = { class: "save_box" }

import Crumb from '@/components/Crumb.vue';
import CUpload from '@/components/CUpload.vue';
import { ElColorPicker } from 'element-plus';
import { Radio, message, Alert, InputNumber } from 'ant-design-vue';
import { CloseCircleOutlined } from '@ant-design/icons-vue';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { ref, computed } from 'vue';
import router from '@/router';
import { useStore } from 'vuex';
import http from '@/api/bullet';
import ClipboardJS from 'clipboard';
import CLoading from '@/components/CLoading.vue';

interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: any;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'bulletChat',
  setup(__props) {

const store = useStore();
const aRadioGroup = Radio.Group;
const aAlert = Alert;
const aInputNumber = InputNumber;
const userData = computed(() => store.state.user.userInfo);
const studioId = router.currentRoute.value.params.studioId;

const tips = ref('仅支持PC端展示');
const status = ref(10);
const bgType = ref(0);
const background = ref('#FFFFFF');
const speed = ref(3);
const colorList = ref(['#00ccb0', '#1890FF', '#FF4D4F', '#FF9337']);
const bulletColorArr = ref(['#55cb44', '#3498db', '#f46825', '#e74c3c', '#e15fd8', '#95a5a6', '#f39c12', '#6c51f3', '#f562d8']);
const bulletColor = ref('#FFFFFF');
const full_url = ref();
//图片上传
const loading = ref<boolean>(false);
const fileList = ref();
const handleChange = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    backupsUrl.value = info.file?.response?.data.url;
  }
  if (info.file.status === 'uploading') {
    loading.value = true;
    return;
  } else loading.value = false;
};
const imgDel = () => {
  backupsUrl.value = '';
};
(info: FileInfo) => handleChange(info);

// 重置
const reset = useDebounce(() => {
  background.value = '#FFFFFF';
});

const delColor = useDebounce((index: number) => {
  bulletColorArr.value.splice(index, 1);
});
const changeColor = () => {
  bulletColorArr.value.push(bulletColor.value);
};

const backupsUrl = ref('');

const showLoading = ref(false);
const getStudioFullScreenBarrage = () => {
  let params = {
    studio_id: studioId,
  };
  showLoading.value = true;
  http
    .getStudioFullScreenBarrage({ params })
    .then((res: any) => {
      bulletColorArr.value = res.data.data.barrage_color;
      speed.value = res.data.data.speed;
      full_url.value = res.data.data.full_url;
      res.data.data.background.includes('https')
        ? ((bgType.value = 1), (backupsUrl.value = res.data.data.background))
        : ((bgType.value = 0), (background.value = res.data.data.background));
      status.value = res.data.data.status;
    })
    .catch((res: any) => {
      message.destroy();
      message.error(res.data.error);
    })
    .finally(() => (showLoading.value = false));
};

getStudioFullScreenBarrage();

const save = useDebounce(() => {
  let params = {
    studio_id: studioId,
    background: bgType.value == 0 ? background.value : backupsUrl.value,
    barrage_color: bulletColorArr.value.toString(),
    speed: speed.value,
    status: status.value,
  };
  http
    .setStudioFullScreenBarrage(params)
    .then((res: any) => {
      message.destroy();
      message.success(res.data.message);
    })
    .catch((res: any) => {
      message.destroy();
      message.error(res.data.error);
    });
});

const jump = () => {
  window.open(full_url.value, '_blank');
};

// 复制
const Cpoyaddress = (btns: string) => {
  let ClipboardJSObj = new ClipboardJS(btns);
  ClipboardJSObj.on('success', function (e) {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', function () {
    message.destroy();
    message.info('复制失败');
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_radio = _resolveComponent("a-radio")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 弹幕上墙 "),
        _createVNode(_component_a_switch, {
          class: "btns_txt",
          checkedValue: 1,
          unCheckedValue: 0,
          checked: status.value,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((status).value = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(save)()))
        }, null, 8, ["checked"])
      ]),
      _createVNode(_unref(aAlert), {
        class: "custom_menu_alert",
        message: tips.value,
        type: "warning",
        "show-icon": ""
      }, null, 8, ["message"]),
      (showLoading.value)
        ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", {
                class: "web_bg_color",
                style: _normalizeStyle({
            background: background.value,
            backgroundImage: bgType.value == 1 ? `url(${backupsUrl.value})` : '',
            backgroundSize: '100%',
          })
              }, null, 4),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (i) => {
                  return _createElementVNode("p", {
                    key: i,
                    style: _normalizeStyle({
              background: bulletColorArr.value[i - 1],
            }),
                    class: _normalizeClass(`item_${i}`)
                  }, [
                    _createElementVNode("img", {
                      src: _unref(userData).avatar,
                      alt: ""
                    }, null, 8, _hoisted_7),
                    _hoisted_8
                  ], 6)
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(" 预览地址： "),
                _createVNode(_component_a_input, {
                  min: 1,
                  value: full_url.value,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((full_url).value = $event)),
                  disabled: "",
                  style: {"flex":"1"}
                }, null, 8, ["value"]),
                _createElementVNode("div", {
                  class: "cpoc_btn",
                  "data-clipboard-text": full_url.value,
                  id: "clipboard",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (Cpoyaddress('#clipboard')))
                }, [
                  _createVNode(_component_a_button, null, {
                    default: _withCtx(() => [
                      _createTextVNode("复制")
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_11),
                _createVNode(_component_a_button, { onClick: jump }, {
                  default: _withCtx(() => [
                    _createTextVNode("打开")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createTextVNode(" 弹幕颜色： "),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bulletColorArr.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      style: _normalizeStyle({ background: item })
                    }, [
                      _createVNode(_unref(CloseCircleOutlined), {
                        class: "del_color",
                        onClick: ($event: any) => (_unref(delColor)(index))
                      }, null, 8, ["onClick"])
                    ], 4))
                  }), 128)),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_button, { class: "add_color_but" }, {
                      default: _withCtx(() => [
                        _createTextVNode("添加颜色")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(ElColorPicker), {
                      modelValue: bulletColor.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((bulletColor).value = $event)),
                      size: "mini",
                      predefine: colorList.value,
                      onChange: changeColor
                    }, null, 8, ["modelValue", "predefine"])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createTextVNode(" 背景设置： "),
                _createVNode(_unref(aRadioGroup), {
                  value: bgType.value,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((bgType).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("背景色")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("背景图")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", null, _toDisplayString(background.value), 1),
                    _createVNode(_unref(ElColorPicker), {
                      modelValue: background.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((background).value = $event)),
                      size: "mini",
                      predefine: colorList.value
                    }, null, 8, ["modelValue", "predefine"])
                  ]),
                  _createVNode(_component_a_button, {
                    class: "reset_but",
                    onClick: _unref(reset)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("重置")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 512), [
                  [_vShow, bgType.value == 0]
                ]),
                _withDirectives(_createVNode(CUpload, {
                  "file-list": fileList.value,
                  "handle-change": handleChange,
                  loading: loading.value,
                  "image-name": backupsUrl.value,
                  "click-stop": imgDel,
                  class: "ant_upload"
                }, null, 8, ["file-list", "loading", "image-name"]), [
                  [_vShow, bgType.value == 1]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createTextVNode(" 滑动速度： "),
                _createVNode(_unref(aInputNumber), {
                  value: speed.value,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((speed).value = $event)),
                  min: 3,
                  max: 30,
                  step: 0.1,
                  style: {"width":"100px"}
                }, null, 8, ["value", "step"]),
                _hoisted_19
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  class: "rich_text_savebut",
                  onClick: _unref(save)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]))
    ])
  ], 64))
}
}

})